import React, { useState } from 'react';
import Rater from 'react-rater';
import Star from '../icon/Star';

const AnimatedRater = ({
  numberRater = 5,
  value = 3,
  onChange,
  activeColor = '#6c19de',
  willBeActiveColor = '#8946e4',
  defaultColor = '#e3e3e3',
}) => {
  const [state, setState] = useState({
    rating: value,
  });

  const handleRate = (e) => {
    setState({
      ...state,
      rating: e.rating,
    });

    onChange(e.rating);
  };

  return (
    <div className="animated-rater">
      <Rater
        total={numberRater}
        rating={state.rating}
        onRate={handleRate}
      >
        <Star
          activeColor={activeColor}
          willBeActiveColor={willBeActiveColor}
          defaultColor={defaultColor}
        />
      </Rater>
    </div>
  );
};

export default AnimatedRater;
